import React, { useMemo } from 'react';
import whats from '@/assets/images/whats.png';
import insta from '@/assets/images/insta.png';
import { waService } from '@/services/domain/WhatsAppService';

const useWhatsAppInfo = () => {
  return useMemo(() => {
    const defaultNumber = waService.getDefaultNumber();
    const formattedDisplay = waService.formatDisplayNumber(defaultNumber);

    try {
      const url = waService.buildUrl();
      return {
        display: formattedDisplay || defaultNumber,
        url,
      };
    } catch (error) {
      console.error('Número do WhatsApp não configurado corretamente.', error);
      return {
        display: formattedDisplay || 'WhatsApp não configurado',
        url: '#',
      };
    }
  }, []);
};

const ContatoPage: React.FC = () => {
  const whatsappInfo = useWhatsAppInfo();
  const whatsappHref = whatsappInfo.url === '#' ? undefined : whatsappInfo.url;

  return (
    <section id="contact" className="contact-section">
      <div className="container">
        <div className="contact-header">
          <p className="contact-subtitle">Estamos sempre prontos para cuidar do seu felino com muito amor e carinho!</p>
        </div>

        <div className="contact-grid">
          {/* Card de Informações */}
          <div className="contact-card info-card">
            <div className="card-header">
              <span className="card-icon">📞</span>
              <h3>Fale Conosco</h3>
            </div>
            <div className="contact-methods">
              <div className="contact-method">
                <img src={whats} alt="WhatsApp" className="method-icon" />
                <div className="method-info">
                  <h4>WhatsApp</h4>
                  <p>{whatsappInfo.display}</p>
                  <a
                    href={whatsappHref}
                    className="btn-contact btn-whatsapp"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-disabled={!whatsappHref}
                  >
                    💬 Conversar Agora
                  </a>
                </div>
              </div>

              <div className="contact-method">
                <img src={insta} alt="Instagram" className="method-icon" />
                <div className="method-info">
                  <h4>Instagram</h4>
                  <p>@acasadosgatos.lages</p>
                  <a href="https://www.instagram.com/acasadosgatos.lages/" className="btn-contact btn-instagram" target="_blank" rel="noopener noreferrer">
                    📸 Seguir no Instagram
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Card de Horários */}
          <div className="contact-card schedule-card">
            <div className="card-header">
              <span className="card-icon">🕒</span>
              <h3>Horário de Funcionamento</h3>
            </div>
            <div className="schedule-list">
              <div className="schedule-item">
                <span className="day">Segunda a Sexta</span>
                <span className="time">9h às 18h</span>
              </div>
              <div className="schedule-item">
                <span className="day">Sábado</span>
                <span className="time">9h às 13h</span>
              </div>
              <div className="schedule-item closed">
                <span className="day">Domingo</span>
                <span className="time">Fechado</span>
              </div>
            </div>
          </div>

          {/* Card do Mapa */}
          <div className="contact-card map-card">
            <div className="card-header">
              <span className="card-icon">📍</span>
              <h3>Nossa Localização</h3>
            </div>
            <div className="map-wrapper">
              <iframe
                src="https://www.google.com/maps?q=Rua+Francisco+de+Paula+Ramos,+104,+Lages,+SC,+88523-020&output=embed"
                width="100%"
                height="300"
                style={{ border: 0, borderRadius: '15px' }}
                allowFullScreen={true}
                loading="lazy"
                title="Localização da A Casa dos Gatos - Rua Francisco de Paula Ramos, 104, Lages"
              />
            </div>
          </div>
        </div>

        {/* Seção de Call to Action */}
        <div className="contact-cta">
          <div className="cta-content">
            <h3>🐱 Pronto para cuidar do seu felino?</h3>
            <p>Entre em contato conosco e agende uma consulta ou tire suas dúvidas!</p>
            <div className="cta-buttons">
              <a
                href={whatsappHref}
                className="btn-cta primary"
                target="_blank"
                rel="noopener noreferrer"
                aria-disabled={!whatsappHref}
              >
                📱 Conversar pelo WhatsApp
              </a>
              <a href="https://www.instagram.com/acasadosgatos.lages/" className="btn-cta secondary" target="_blank" rel="noopener noreferrer">
                📷 Ver no Instagram
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContatoPage;